import { omit } from "remeda";
import { CreateCardFormValues } from "../schemas/formSchemas";
import { UserTestCardFromList } from "../schemas/userTestCardsApiSchemas";

const getFormValuesFromCard: (
  card: UserTestCardFromList
) => CreateCardFormValues = omit(["id", "actions"]);

export default getFormValuesFromCard;
